import React from "react";

import styles from "./TwoLineGridCell.module.scss";

interface Props {
  firstLineData?: React.ReactNode;
  secondLineData?: React.ReactNode;
  helperNode?: React.ReactNode;
}

const TwoLineGridCell = (props: Props) => {
  const { firstLineData, secondLineData, helperNode } = props;

  return (
    <>
      <div className={styles.firstLineBlock}>
        <div className={styles.firstLine}>{firstLineData}</div>
        {helperNode}
      </div>
      <div className={styles.secondLine}>{secondLineData}</div>
    </>
  );
};

export default TwoLineGridCell;
